<div class="fremium-modal" (click)="onClose()">
  <div class="fremium-modal-content" (click)="$event.stopPropagation()">
    <div class="fremium-modal-header">
      <button class="fremium-modal-close" (click)="onClose()" type="button">
        <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M12 4L4 12M4 4L12 12" stroke="#1F2326" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
      </button>
      <img
        src="assets/shared/img/partners/iconografia-fremium.svg"
        alt="Fremium Icon"
        width="48"
        height="48"
        style="margin-bottom: 16px"
      />
      <h2 class="fremium-modal-title">Desbloqueie este benefício agora!</h2>
    </div>

    <p class="fremium-modal-text">
      Este benefício é exclusivo para assinantes Premium! Faça o upgrade e desbloqueie vantagens!
    </p>

    <div class="fremium-modal-benefits">
      <div class="fremium-modal-benefit-item">
        <div class="fremium-modal-benefit-icon">
          <img src="assets/shared/img/iconDesbloqueio/icon-1-desbloqueio.svg" alt="Benefício 1" width="24" height="24" />
        </div>
        <span class="fremium-modal-benefit-text">Acesso a base completa com + de 30 mil parceiros</span>
      </div>

      <div class="fremium-modal-benefit-item">
        <div class="fremium-modal-benefit-icon">
          <img src="assets/shared/img/iconDesbloqueio/icon-2-desbloqueio.svg" alt="Benefício 2" width="24" height="24" />
        </div>
        <span class="fremium-modal-benefit-text">Convide e indique novos parceiros para a plataforma</span>
      </div>

      <div class="fremium-modal-benefit-item">
        <div class="fremium-modal-benefit-icon">
          <img src="assets/shared/img/iconDesbloqueio/icon-3-desbloqueio.svg" alt="Benefício 3" width="24" height="24" />
        </div>
        <span class="fremium-modal-benefit-text">Compras de ingressos de cinema ilimitadas</span>
      </div>

      <div class="fremium-modal-benefit-item">
        <div class="fremium-modal-benefit-icon">
          <img src="assets/shared/img/iconDesbloqueio/icon-4-desbloqueio.svg" alt="Benefício 4" width="24" height="24" />
        </div>
        <span class="fremium-modal-benefit-text">E tem muito mais esperando por você!</span>
      </div>
    </div>

    <div class="fremium-modal-buttons">
      <button class="fremium-modal-button" (click)="onAssinarPremium()">
        Assinar o premium
      </button>

      <button class="fremium-modal-button-secondary" (click)="onVoltar()">
        Voltar para a página anterior
      </button>
    </div>
  </div>
</div>
